import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Index from "./pages/Index";

const Eripuhastus = lazy(() => import("./pages/Eripuhastus"));
const AkendePesu = lazy(() => import("./pages/AkendePesu"));
const VaipkatedeSuvapesu = lazy(() => import("./pages/VaipkatedeSuvapesu"));
const PehmeMoobliPuhastus = lazy(() => import("./pages/PehmeMoobliPuhastus"));
const PorandateSuvapesu = lazy(() => import("./pages/PorandateSuvapesu"));
const EhitusjargneKoristus = lazy(() => import("./pages/EhitusjargneKoristus"));
const Aurupuhastus = lazy(() => import("./pages/Aurupuhastus"));
const Hoolduskoristus = lazy(() => import("./pages/Hoolduskoristus"));
const KontoriteKoristus = lazy(() => import("./pages/KontoriteKoristus"));
const KorteriuhistuteKoristus = lazy(() => import("./pages/KorteriuhistuteKoristus"));
const Kodukoristus = lazy(() => import("./pages/Kodukoristus"));
const TrepikodadeKoristus = lazy(() => import("./pages/TrepikodadeKoristus"));
const Valiskoristused = lazy(() => import("./pages/Valiskoristused"));
const Fassaadipesu = lazy(() => import("./pages/Fassaadipesu"));
const KatusePesu = lazy(() => import("./pages/KatusePesu"));
const LumekoristusKatusel = lazy(() => import("./pages/LumekoristusKatusel"));
const LumekoristusRakveres = lazy(() => import("./pages/LumekoristusRakveres"));
const TerrassidePuhastus = lazy(() => import("./pages/TerrassidePuhastus"));
const VihmaveerennidePuhastus = lazy(() => import("./pages/VihmaveerennidePuhastus"));
const TanavakividePesu = lazy(() => import("./pages/TanavakividePesu"));
const Hinnakiri = lazy(() => import("./pages/Hinnakiri"));
const Galerii = lazy(() => import("./pages/Galerii"));
const Haljastus = lazy(() => import("./pages/Haljastus"));
const MuruNiitmine = lazy(() => import("./pages/MuruNiitmine"));
const LehtedKoristus = lazy(() => import("./pages/LehtedKoristus"));
const JaatmedAravedu = lazy(() => import("./pages/JaatmedAravedu"));
const NotFound = lazy(() => import("./pages/NotFound"));

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/eripuhastus" element={<Eripuhastus />} />
          <Route path="/eripuhastus/akende-pesu" element={<AkendePesu />} />
          <Route path="/eripuhastus/vaipkatete-suvapesu" element={<VaipkatedeSuvapesu />} />
          <Route path="/eripuhastus/pehme-moobli-puhastus" element={<PehmeMoobliPuhastus />} />
          <Route path="/eripuhastus/porandate-suvapesu" element={<PorandateSuvapesu />} />
          <Route path="/eripuhastus/ehitusjargne-koristus" element={<EhitusjargneKoristus />} />
          <Route path="/eripuhastus/aurupuhastus" element={<Aurupuhastus />} />
          <Route path="/hoolduskoristus" element={<Hoolduskoristus />} />
          <Route path="/hoolduskoristus/kontorid" element={<KontoriteKoristus />} />
          <Route path="/hoolduskoristus/korteriuhistud" element={<KorteriuhistuteKoristus />} />
          <Route path="/hoolduskoristus/kodukoristus" element={<Kodukoristus />} />
          <Route path="/hoolduskoristus/trepikojad" element={<TrepikodadeKoristus />} />
          <Route path="/valiskoristused" element={<Valiskoristused />} />
          <Route path="/valiskoristused/fassaadipesu" element={<Fassaadipesu />} />
          <Route path="/valiskoristused/katuse-pesu" element={<KatusePesu />} />
          <Route path="/valiskoristused/lumekoristus-katusel" element={<LumekoristusKatusel />} />
          <Route path="/valiskoristused/lumekoristus-rakveres" element={<LumekoristusRakveres />} />
          <Route path="/valiskoristused/terrasside-puhastus" element={<TerrassidePuhastus />} />
          <Route path="/valiskoristused/vihmaveerennide-puhastus" element={<VihmaveerennidePuhastus />} />
          <Route path="/valiskoristused/tanavakivide-pesu" element={<TanavakividePesu />} />
          <Route path="/haljastus" element={<Haljastus />} />
          <Route path="/haljastus/muru-niitmine" element={<MuruNiitmine />} />
          <Route path="/haljastus/lehtede-koristus" element={<LehtedKoristus />} />
          <Route path="/haljastus/jaatmete-aravedu" element={<JaatmedAravedu />} />
          <Route path="/hinnakiri" element={<Hinnakiri />} />
          <Route path="/galerii" element={<Galerii />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </TooltipProvider>
);

export default App;
